import ko from 'knockout';
import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class ViewModel {
  constructor({
    setting = {},
  }) {
    this.selectedItem = ko.observable();
    this.disabledItems = ko.observable('');
    this.setting = ko.observable(setting);

    this.enableCustomLabel = ko.computed(() => {
      const campaignSetting = this.setting();

      return _.result(config.get('Permissions'), 'IsDynamicSearchAdsPageFeedEnabled') && campaignSetting.Source !== 'SystemIndex' && _.size(campaignSetting.Source) > 0;
    });

    const permissions = config.get('Permissions');

    const urlEqualsEnabled = permissions && permissions.dynamic && permissions.dynamic.DSAUrlEquals;

    this.radiogroup = ko.computed(() => {
      const options = [
        {value: 'category', text: i18n.get('DSA_AutoTargets_Dropdown_Title_Category'), popupId: 'pop_BA_CampaignCreate_Keywords_RecommendedCats', isDisabled: this.disabledItems().indexOf('category') >= 0 },
        {value: 'allwebpage', text: i18n.get('DSA_AutoTargets_Dropdown_Title_All'), popupId: 'pop_BA_CampaignCreate_Keywords_AllPages', isDisabled: this.disabledItems().indexOf('allwebpage') >= 0},
        {value: urlEqualsEnabled ? 'mixedspecificwebpage' : 'specificpage', text: i18n.get('DSA_AutoTargets_Dropdown_Title_Specific'), popupId: 'pop_BA_CampaignCreate_Keywords_SpecificPages', isDisabled: this.disabledItems().indexOf('specificpage') >= 0 },
      ];

      if (this.enableCustomLabel()) {
        options.push({
          value: 'customlabel',
          text: i18n.get('DSA_AutoTargets_Dropdown_Title_Custom_Label'),
          popupId: 'pop_BA_PageFeeds_CustomLabel',
          isDisabled: this.disabledItems().indexOf('customlabel') >= 0,
        });
      }
      return options;
    });

    this.radiogroup.subscribe((radios) => {
      const radio = _.findWhere(radios, { value: this.selectedItem() });

      if (!radio) {
        this.selectedItem('allwebpage');
      }
    });
  }
}
